import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatHubContext = createContext();

export const useChatHub = () => {
  const context = useContext(ChatHubContext);
  if (!context) {
    throw new Error('useChatHub must be used within a ChatHubProvider');
  }
  return context;
};

export const ChatHubProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [toggleFunction, setToggleFunction] = useState(null);

  const updateUnreadCount = useCallback((count) => {
    setUnreadCount(count);
  }, []);

  const updateToggleFunction = useCallback((fn) => {
    setToggleFunction(() => fn);
  }, []);

  const openChatHub = useCallback(() => {
    if (toggleFunction) {
      toggleFunction();
    }
  }, [toggleFunction]);

  return (
    <ChatHubContext.Provider value={{
      unreadCount,
      updateUnreadCount,
      updateToggleFunction,
      openChatHub
    }}>
      {children}
    </ChatHubContext.Provider>
  );
};